import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { Timer } from './timer';
export { Timer };
import { timerSchema } from '@schemas/business-objects/timer';
import { TokenFormGroup } from './token-form-group';

export class TimerFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    boundaryEventId: SchemaFormControl;
    interrupting: SchemaFormControl;
    fireAt: SchemaFormControl;
    status: SchemaFormControl;
    createdAt: SchemaFormControl;
    updatedAt: SchemaFormControl;
    tokenId: SchemaFormControl;
    token: TokenFormGroup;
  };

  declare value: Partial<Timer>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(timerSchema, Timer, data, options);
  }

  get object(): Timer {
    return new Timer(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'token':
        return new TokenFormGroup();
      default:
        return undefined;
    }
  }

  async fire(): Promise<any> {
    const instance = new Timer(this.value);
    return instance.fire();
  }
}

export class TimerFormArray extends PersistedFormArray {
  readonly entityName = 'Timer' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(timerSchema, Timer, options);
  }

  protected override createItemGroup() {
    return new TimerFormGroup();
  }

  get array(): Timer[] {
    return this.controls.map((group: TimerFormGroup) => group.object);
  }
}

export class TimerPersistedArray extends PersistedArray<Timer> {
  readonly entityName = 'Timer' as const;

  constructor(options?: PersistedArrayOptions) {
    super(Timer, options);
  }
}
